var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___c2s1LV",
  "pG": "ChannelOverviewTab.module__regionEmoji___c2s1LV",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___c2s1LV",
  "c5": "ChannelOverviewTab.module__topicInput___c2s1LV",
  "Z8": "ChannelOverviewTab.module__emojiButton___c2s1LV",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___c2s1LV",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___c2s1LV",
  "p9": "ChannelOverviewTab.module__sectionWrapper___c2s1LV",
  "h3": "ChannelOverviewTab.module__settingsGroup___c2s1LV",
  "hB": "ChannelOverviewTab.module__settingsControlRow___c2s1LV",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___c2s1LV",
  "Y4": "ChannelOverviewTab.module__settingsControlText___c2s1LV",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___c2s1LV",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___c2s1LV",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___c2s1LV",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___c2s1LV",
};

module.exports = exports;
